import { AxiosResponse } from 'axios';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { call, takeEvery, put } from 'redux-saga/effects';
import { postAPI } from 'commons/framework/KeyFlowAPIRequest';
import { API } from 'commons/constants/KeyFlowAPI';

import {
  requestStatisticsLogSuccess,
  requestStatisticsLogFailure,
} from 'redux/actions/statisticsLog/actions';

import { REQUEST_STATISTICS_LOG } from 'redux/actions/statisticsLog/types';
import { throwError } from 'redux/actions/actions';

/**
 *
 * @param action {RequestStatisticsLogAction}
 */
function* requestStatisticsLog(action: RequestStatisticsLogAction) {
  const { param } = action.payload;
  console.debug({ param });

  try {
    const response: AxiosResponse = yield call(postAPI, API.STATISTICS_LOG, param);
    console.debug({ response });

    const keyFlowResponse = new KeyFlowResponse(response.data);
    const [firstResult] = keyFlowResponse.getResult();
    console.debug({ firstResult });

    const streamingCount = firstResult.STREAMING_COUNT;

    yield put(requestStatisticsLogSuccess({ streamingCount }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestStatisticsLogFailure());
  }
}

export function* watchStatisticsLogSaga() {
  yield takeEvery(REQUEST_STATISTICS_LOG, requestStatisticsLog);
}
